(function () {
  function readConfig() {
    var node = document.getElementById('theme-config-json');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function apply(config) {
    window.theme = {
      info: config.info,
      mediaQueries: config.mediaQueries,
      device: {
        hasTouch: window.matchMedia('(any-pointer: coarse)').matches,
        hasHover: window.matchMedia('(hover: hover)').matches
      },
      routes: config.routes,
      settings: config.settings,
      strings: config.strings,
      scripts: config.scripts
    };

    if (config.recentlyViewedProductId) {
      try {
        var items = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
        var id = config.recentlyViewedProductId;
        if (!items.includes(id)) items.unshift(id);
        localStorage.setItem('cc-recently-viewed', JSON.stringify(items.slice(0, 12)));
      } catch (e) { /* ignore */ }
    }
  }

  var config = readConfig();
  if (config) apply(config);
})();
